import type React from "react";
import { useEffect } from "react";

export default function useKeyboard(ref: React.RefObject<HTMLDivElement | null>) {
  const innerHeight = window.innerHeight;
  const visualHeight = parseInt(String(window.visualViewport?.height));

  useEffect(() => {
    const element = ref.current;
    if (element) {
      if (innerHeight > visualHeight) {
        element.style.setProperty("height", `${visualHeight}px`);
      } else {
        element.style.setProperty("height", "auto");
      }
    }
  }, [ref, innerHeight, visualHeight]);
}
